<template>
    <div :class="['data_population', ['Safety', 'Realcity'].includes(selectedTopMenu) ? 'pos2' : '']">
        <h4 style="width: 100%;">{{ dispTitleList[slideIdx] }}</h4>
        <div class="grph_area mt-5 swiper-container">
            <div class="swiper-wrapper">
                <div v-for="(chartId, index) in dispChartIds" class="swiper-slide">
                    <Chart :key="chartId" :chartid="chartId" v-if="index === slideIdx" />
                </div>
            </div>
            <div class="btn_pre swiper-button-prev"></div>
            <div class="btn_nxt swiper-button-next"></div>
        </div>
    </div>
</template>

<script>
import Swiper from '@/assets/js/swiperjs/swiper-bundle.js';
import gripUtil from "@/libs/grip.util";
import { $_TYPE, $_WC } from '@/confs/common.const';
import Chart from '@/libs/grip.chart.v2.vue';
import { mapGetters } from "vuex";
export default {
    components: {
        Chart,
    },
    data() {
        return {
            swiper: undefined,
            slideIdx: 0,
        }
    },
    watch: {
        // 시설정보 체크박스 선택 변경 감지
        selectedTopMenu: {
            immediate: false,
            handler (newVal, oldVal) {
                if(typeof this.swiper === $_TYPE.UNDEF) {
                    this.setSwiper();
                }
            }
        },
        dispChartIds: {
            immediate: false,
            handler(newVal, oldVal) {
                this.$nextTick(()=> {
                    this.setSwiper();
                });
            }
        },
    },
    computed: {
        ...mapGetters({
            topMenuList: 'getTopMenuList',
            selectedTopMenu: 'getSelectedTopMenu',
            selectedSubMenus:'getSelectedSubMenus',
        }),
        topMenuMap() {
            return gripUtil.toDict(this.topMenuList, 'code');
        },
        title(){
            let title = '';
            if(this.selectedTopMenu == '') {
                return title;
            } else {
                return this.topMenuMap[this.selectedTopMenu].chartTitles;
            }
        },
        chartIds(){
            let chartIds = [936, 463, 464];
            if(this.selectedTopMenu == '') {
                return chartIds;
            } else {
                return this.topMenuMap[this.selectedTopMenu].chartIds;
            }
        },
        dispTitleList() {
            let titleList = [];
            titleList = this.title;
            if(this.selectedSubMenus.includes('mosquito')) {
                titleList = ['일별 모기방역 현황', '월별 모기방역 현황'];
            } else if(this.selectedSubMenus.includes('mediumMosq')) {
                titleList = ['주간 매개모기 현황', '월별 매개모기 현황']
            }
            return titleList;
        },
        dispChartIds() {
            let dispChartList =[];
            dispChartList = this.chartIds
            if(this.selectedSubMenus.includes('mosquito')) {
                dispChartList = [1316, 1317];
            } else if(this.selectedSubMenus.includes('mediumMosq')) {
                dispChartList = [1376, 1377];
            }
            return dispChartList;
        },
    },
    mounted() {
        if(typeof this.swiper === $_TYPE.UNDEF) {
            this.setSwiper();
        }
    },
    methods: {
        setSwiper(){
            const _this = this;
            if(typeof this.swiper !== $_TYPE.UNDEF) {
                this.swiper.slideTo(0);
            }
            this.swiper = new Swiper('.swiper-container', {
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                slidesPerView : 1,
                // effect : 'coverflow',
                pagination: {
                    el: '.swiper-pagination'
                },
                /*
                autoplay: {
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                */
                mousewheel: true,
                keyboard: true,
                on: {
                    init() {
                    },
                    slideChange(e){
                        _this.slideIdx = this.realIndex;
                        _this.$eventBus.$emit("Swiper::slide-change");
                    },
                    touchMove(){
                        _this.$eventBus.$emit("Swiper::touch-move");
                    },
                },
            });
        },
    },
};
</script>
